module.exports = __webpack_public_path__ + "dfb347220dcced373f5a7f1b4d60e670.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/destructive_abilities-768.webp
// module id = 255
// module chunks = 0